import { render, staticRenderFns } from "./ViewEmailInfoCard.vue?vue&type=template&id=70703af8&scoped=true"
import script from "./ViewEmailInfoCard.vue?vue&type=script&lang=js"
export * from "./ViewEmailInfoCard.vue?vue&type=script&lang=js"
import style0 from "./ViewEmailInfoCard.vue?vue&type=style&index=0&id=70703af8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70703af8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VExpansionPanelContent,VRow})
